import { render, staticRenderFns } from "./NewCardForAdd.vue?vue&type=template&id=e8388886"
import script from "./NewCardForAdd.vue?vue&type=script&lang=js"
export * from "./NewCardForAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports